import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Form, Button } from "react-bootstrap";

import {
  fetchVehicle,
  fetchVehicleMaintenance,
  updateVehicleMaintenance,
  resetUpdateVehicleMaintenance,
} from "../../store/actions/vehicle";
import { showAlertDialog } from "../../store/actions/dialog";
import {
  inputErrorHandler,
  signalTransitionSuccess,
  signalTransitionError,
  removeEmptyValues,
  getFileContent,
  checkFileType,
  getMaxBase64StringSize,
  FILE_TOO_LARGE_MESSAGE,
  FILE_NAME_SEPARATOR,
  FILE_TYPE_MESSAGE,
  CORE_MODULE,
  VEHICLE_MAINTENANCE_ENTITY,
} from "../../utils";
import { DateTimePicker } from "react-tempusdominus-bootstrap";
import bsCustomFileInput from "bs-custom-file-input";
import moment from "moment";
import ColumnText from "../../components/Column";

import "react-bootstrap-typeahead/css/Typeahead.css";
import "font-awesome/css/font-awesome.css";
import "tempusdominus-bootstrap/build/css/tempusdominus-bootstrap.css";

class MaintenanceEditScreen extends Component {
  vehicleId = null;

  constructor(props) {
    super(props);
    this.vehicleId = props.match.params.vid;
    this.state = {
      fields: {
        maintenance_id: "",
        vehicle_id: "",
        vehicle_name: "",
        mant_date: moment(),
        mileage: "",
        note: "",
        files: "",
      },
      reset: {
        fields: {
          maintenance_id: "",
          vehicle_name: "",
          vehicle_id: "",
          mant_date: moment(),
          mileage: "",
          note: "",
          files: "",
        },
        errors: {
          vehicle_id: "",
          mant_date: "",
          mileage: "",
          note: "",
          files: "",
        },
      },
      errors: {
        vehicle_id: "",
        mant_date: "",
        mileage: "",
        note: "",
        files: "",
      },
      fileName: "No File Choosen",
      defaultName: "No File Choosen",
      value: "",
      suggestions: [],
    };
    this.field = React.createRef();
    this.datePickerHandler = this.datePickerHandler.bind(this);
    this.changeFileHandler = this.changeFileHandler.bind(this);
  }

  componentDidMount() {
    bsCustomFileInput.init();

    let data = {};
    data.conds = { "me.id": this.props.match.params.id };
    data.attrs = {};
    data.attrs["prefetch"] = ["owning_customer", "vehicle"];
    this.props.dispatch(fetchVehicleMaintenance(data));

    let vdata = {};
    vdata.attrs = {};
    vdata.conds = {};
    this.props.dispatch(fetchVehicle(vdata));
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      JSON.stringify(prevProps.vehicleData) !==
      JSON.stringify(this.props.vehicleData)
    ) {
      let vehicles =
        typeof this.props.vehicleData !== "undefined" &&
        typeof this.props.vehicleData.rows !== "undefined" &&
        typeof this.props.vehicleData.rows.data !== "undefined"
          ? this.props.vehicleData.rows.data
          : [];
      let data = [];
      let suggestions = this.state.suggestions;
      for (let i = 0; i < suggestions.length; i++) {
        let obj = {};
        obj.id = suggestions.id;
        obj.name = suggestions.name;
        data.push(obj);
      }
      for (let i = 0; i < vehicles.length; i++) {
        let obj = {};
        obj.id = vehicles[i].id;
        obj.name = vehicles[i].vin;
        data.push(obj);
      }

      this.setState({ suggestions: data });
    }
    if (
      JSON.stringify(prevProps.maintenanceData) !==
      JSON.stringify(this.props.maintenanceData)
    ) {
      let mntID = this.props.match.params.id;
      let customer_data =
        typeof this.props.maintenanceData.rows.data[0] !== "undefined"
          ? this.props.maintenanceData.rows.data[0]
          : null;
      let vehicle_data =
        customer_data !== null && typeof customer_data.vehicle !== "undefined"
          ? customer_data.vehicle
          : null;
      let owning_customer =
        customer_data !== null &&
        typeof customer_data.owning_customer !== "undefined"
          ? customer_data.owning_customer
          : null;

      let vehicle_id =
        vehicle_data !== null && typeof vehicle_data.id !== "undefined"
          ? vehicle_data.id
          : "-";
      let vehicle_name =
        vehicle_data !== null && typeof vehicle_data.vin !== "undefined"
          ? vehicle_data.vin
          : "";

      let maint_date =
        customer_data !== null && typeof customer_data.date !== "undefined"
          ? moment(customer_data.date).format("YYYY-MM-DD")
          : "-";
      let mileage =
        customer_data !== null &&
        typeof customer_data.mileage !== "undefined" &&
        customer_data.mileage !== null
          ? customer_data.mileage
          : "";
      let service_note =
        customer_data !== null && typeof customer_data.note !== "undefined"
          ? customer_data.note
          : "-";
      let service_invoice =
        customer_data !== null &&
        typeof customer_data.invoice !== "undefined" &&
        customer_data.invoice !== null
          ? JSON.parse(customer_data.invoice)
          : "-";
      let fileName =
        service_invoice === "-" ? "" : service_invoice.original_name;

      let maintenance = {};
      maintenance["maintenance_id"] = mntID;
      maintenance["vehicle_id"] = vehicle_id;
      maintenance["vehicle_name"] = vehicle_name;
      maintenance["maint_date"] = maint_date;
      maintenance["mileage"] = mileage;
      maintenance["note"] = service_note;
      maintenance["files"] = "";

      if (fileName) {
        this.setState({ fileName: fileName });
      }

      this.setState({ fields: maintenance });
      this.setState({ reset: maintenance });
      this.setState({ value: vehicle_name });
    }
    if (this.props.updateData.success) {
      this.props.dispatch(resetUpdateVehicleMaintenance());
      signalTransitionSuccess("Update Success");
      let url = "/admin/maintenance";
      if (this.vehicleId) {
        url = "/admin/vehicles/" + this.vehicleId + "/maintenance";
      }
      this.props.history.push(url);
    } else if (this.props.updateData.error) {
      this.props.dispatch(resetUpdateVehicleMaintenance());
      signalTransitionError("Update Failed");
    }
  }

  resetHandler(evt) {
    this.setState({ fields: this.state.reset.fields });
    this.setState({ errors: this.state.reset.errors });
  }

  submitHandler(evt) {
    evt.preventDefault();
    // get our new errors

    let fields = this.state.fields;
    let newErrors = {};
    newErrors["vehicle_id"] = inputErrorHandler("", fields.vehicle_id, true);
    newErrors["note"] = inputErrorHandler("", fields.note, true);
    newErrors["maint_date"] = inputErrorHandler("", fields.maint_date, true);
    newErrors["mileage"] = inputErrorHandler("", fields.mileage, true);
    if (fields.vehicle_id === "" || fields.vehicle_name === "") {
      newErrors["vehicle_id"] = "Required Parameter";
    } else if (fields.vehicle_name !== this.state.value) {
      newErrors["vehicle_id"] = "Please select valid Vehicle ID";
    }

    console.log(newErrors);
    let errors = removeEmptyValues(newErrors);
    if (Object.keys(errors).length > 0) {
      this.setState({ errors: errors });
    } else {
      let maintenanceData = {
        maintenance_id: fields.maintenance_id,
        maintenance: {},
      };

      maintenanceData.maintenance.date = fields.maint_date;
      if (fields.files !== "") {
        maintenanceData.maintenance.invoice = fields.files;
      }
      maintenanceData.maintenance.note = fields.note;
      maintenanceData.maintenance.mileage = fields.mileage;

      this.props.dispatch(updateVehicleMaintenance(maintenanceData));
    }
  }

  changeHandler(evt, name) {
    let value = evt.target.value;
    this.setState((prevState) => ({
      fields: {
        ...prevState.fields,
        [name]: value,
      },
      errors: {
        ...prevState.errors,
        [name]: null,
      },
    }));
  }

  datePickerHandler(value) {
    let items = this.state.fields;
    items["maint_date"] = value;
    this.setState({ fields: items });

    let errors = this.state.errors;
    errors["maint_date"] = "";
    this.setState({ errors: errors });
  }

  changeFileHandler(evt) {
    if (
      typeof evt.target.files[0] !== "undefined" &&
      typeof evt.target.files[0].name !== "undefined"
    ) {
      this.setState({ fileName: evt.target.files[0].name });
      if (checkFileType(evt.target.files)) {
        getFileContent(evt.target.files)
          .then((data) => {
            if (data.length > getMaxBase64StringSize()) {
              this.props.dispatch(showAlertDialog(FILE_TOO_LARGE_MESSAGE));
              this.setState({ fileName: this.state.defaultName });
              let fields = this.state.fields;
              fields["files"] = "";
              this.setState({ fields: fields });
            } else {
              console.log(
                `${this.state.fileName}${FILE_NAME_SEPARATOR}${data}`
              );
              let fields = this.state.fields;
              fields[
                "files"
              ] = `${this.state.fileName}${FILE_NAME_SEPARATOR}${data}`;
              this.setState({ fields: fields });
            }
          })
          .catch((e) => console.log("Error: ", e.message));
      } else {
        this.props.dispatch(showAlertDialog(FILE_TYPE_MESSAGE));
        this.setState({ fileName: this.state.defaultName });
        let fields = this.state.fields;
        fields["files"] = "";
        this.setState({ fields: fields });
      }
    }
  }

  onValueChange = (newValue) => {
    this.setState({
      value: newValue,
    });
  };

  onSuggestionsFetchRequested = (value) => {
    this.loadSuggestions(value);
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  loadSuggestions(value) {
    if (value !== "") {
      let vdata = {};
      vdata.attrs = {};
      vdata.conds = { vin: { "-like": "%" + value + "%" } };
      this.props.dispatch(fetchVehicle(vdata));
    }
  }

  loadMoreReferences = () => {
    let meta_data =
      typeof this.props.vehicleData !== "undefined" &&
      typeof this.props.vehicleData.rows !== "undefined" &&
      typeof this.props.vehicleData.rows.meta !== "undefined"
        ? this.props.vehicleData.rows.meta
        : [];

    let vdata = {};
    vdata.attrs = {};
    vdata.conds = meta_data.conds;
    vdata.page = meta_data.page + 1;
    vdata.page_size = meta_data.page_size;
    this.props.dispatch(fetchVehicle(vdata));
  };

  onSelect = (suggestionValue) => {
    const reference = this.state.suggestions.find(
      (r) => r["name"] === suggestionValue
    );

    let fields = this.state.fields;
    fields["vehicle_id"] = reference.id;
    fields["vehicle_name"] = reference.name;
    this.setState({ fields: fields });
  };

  setFieldPlaceholder = () => {
    if (
      typeof this.field.current[0] !== "undefined" &&
      typeof this.field.current[0].children[0] !== "undefined"
    ) {
      this.field.current[0].children[0].setAttribute("placeholder", "Datum");
    }
  };
  render() {
    return (
      <div className="wrapper">
        <div className="main d-flex align-items-start flex-column">
          <h4>
            <ColumnText
              Module={CORE_MODULE}
              Entity={VEHICLE_MAINTENANCE_ENTITY}
            />{" "}
            bearbeiten
          </h4>
        </div>
        <div className="sub_main">
          <Form>
            <Row>
              <Col lg={6}>
                <Form.Group as={Row} controlId="vehicle_id">
                  <Form.Label column sm="4">
                    <ColumnText
                      Module={CORE_MODULE}
                      Entity={VEHICLE_MAINTENANCE_ENTITY}
                      Label={"vehicle"}
                    />
                  </Form.Label>
                  <Col sm="8">
                    <div className="col-sm-8">{this.state.value}</div>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="maint_date">
                  <Form.Label column sm="4">
                    <ColumnText
                      Module={CORE_MODULE}
                      Entity={VEHICLE_MAINTENANCE_ENTITY}
                      Label={"date"}
                    />
                  </Form.Label>
                  <Col sm="8">
                    <DateTimePicker
                      pickerRef={this.field}
                      callback={() => this.setFieldPlaceholder()}
                      date={
                        this.state.fields ? this.state.fields.maint_date : null
                      }
                      format="YYYY-MM-DD"
                      onChange={(e) => this.datePickerHandler(e.date)}
                    />
                    <Form.Control.Feedback type="invalid">
                      {this.state.errors ? this.state.errors.maint_date : null}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="mileage">
                  <Form.Label column sm="4">
                    <ColumnText
                      Module={CORE_MODULE}
                      Entity={VEHICLE_MAINTENANCE_ENTITY}
                      Label={"mileage"}
                    />
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      type="text"
                      placeholder="Mileage"
                      name="mileage"
                      value={this.state.fields.mileage}
                      onChange={(evt) => this.changeHandler(evt, "mileage")}
                      onKeyPress={this.onKeyPress}
                      isInvalid={!!this.state.errors.mileage}
                    />
                    <Form.Control.Feedback type="invalid">
                      {this.state.errors.mileage}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="note">
                  <Form.Label column sm="4">
                    <ColumnText
                      Module={CORE_MODULE}
                      Entity={VEHICLE_MAINTENANCE_ENTITY}
                      Label={"note"}
                    />
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Note"
                      name="note"
                      value={this.state.fields ? this.state.fields.note : ""}
                      onChange={(evt) => this.changeHandler(evt, "note")}
                      onKeyPress={this.onKeyPress}
                      isInvalid={
                        !!(this.state.errors ? this.state.errors.note : null)
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {this.state.errors ? this.state.errors.note : ""}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="invoice">
                  <Form.Label column sm="4">
                    <ColumnText
                      Module={CORE_MODULE}
                      Entity={VEHICLE_MAINTENANCE_ENTITY}
                      Label={"invoice"}
                    />
                  </Form.Label>
                  <Col sm="8">
                    <Form.File
                      type="file"
                      // className="custom-file-label"
                      id="inputGroupFile01"
                      label={this.state.fileName}
                      onChange={(evt) => this.changeFileHandler(evt)}
                      accept="application/pdf, image/*"
                      custom
                    />
                    <Form.Control.Feedback type="invalid">
                      {this.state.errors ? this.state.errors.mileage : null}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>

                <div className="form-btn">
                  <Button
                    type="Button"
                    className="btn btn-dark Button"
                    onClick={(evt) => this.submitHandler(evt)}
                  >
                    OK
                  </Button>
                  <Button
                    type="Button"
                    className="btn btn-dark"
                    onClick={(evt) => this.resetHandler(evt)}
                  >
                    Abbrechen
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}

MaintenanceEditScreen.propTypes = {};
MaintenanceEditScreen.defaultProps = {};

const mapStateToProps = (state) => ({
  customerData: state.Customer.customerData,
  vehicleData: state.Vehicle.vehicleData,
  localeData: state.Locale.localeData,
  updateData: state.Maintenance.updateData,
  dialogData: state.Dialog.dialogData,
  maintenanceData: state.Maintenance.maintenanceData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

// We normally do both in one step, like this:
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MaintenanceEditScreen);
